import { Card } from "@/components/ui/card";
import { Printer } from "lucide-react";
import { StripeSection } from "./integrations/StripeSection";
import { XeroSection } from "./integrations/XeroSection";
import { EmailNotifySection } from "./integrations/EmailNotifySection";
import { PrintSetupGuide } from "./integrations/PrintSetupGuide";

/** Super-admin-only hub for 3rd-party integrations (Stripe payments,
 * Xero accounting). All values are stored in the shared database so they
 * apply to preview AND production instantly — no redeploy required. */
export default function IntegrationsTab() {
  return (
    <div className="space-y-6 max-w-4xl" data-testid="integrations-tab">
      <p className="text-sm text-muted-foreground">
        API credentials and account settings for connected services. Values are stored securely
        in the database and take effect immediately across all environments.
      </p>
      <StripeSection />
      <XeroSection />
      <EmailNotifySection />

      {/* Silent-print (kiosk) setup — one-time per workstation, no backend
          config needed. Shown here so operators can find it alongside the
          other integrations. */}
      <Card className="p-5" data-testid="printer-section">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <Printer className="h-5 w-5 text-brand-navy" />
            <h3 className="font-semibold text-brand-navy">Silent Printing (Kiosk Mode)</h3>
          </div>
          <PrintSetupGuide />
        </div>
        <p className="text-sm text-muted-foreground">
          Delivery cards and manifests already trigger the print dialog automatically. To make
          them print silently to the default printer without any dialog, launch Chrome with the
          <code className="mx-1 px-1 py-0.5 bg-neutral-100 border rounded text-xs">--kiosk-printing</code>
          flag on each dispatch/packing workstation. Click <strong>Silent-print Setup</strong> above
          for the full one-time setup guide (Windows / macOS).
        </p>
      </Card>
    </div>
  );
}
